import './featuredactions.scss'

import {ActionCard} from './actions/actioncard'
import {ButtonPrimary} from 'views/ui/Button'
import {FeaturedType} from 'campagne/types'
import React from 'react'
import {Theme} from 'views/campagne/theme'
import {style} from 'util/campagne/style'

const styles = style('featuredactions')

export const FeaturedActions: React.FC<FeaturedType> = ({
	title,
	actions,
	link
}) => {
	if (!actions || actions.length === 0) return null

	const filteredActions = actions.filter((action) => action !== null)
	if (filteredActions.length === 0) return null

	return (
		<div class={styles}>
			<div class={styles('title')}>
				<Theme.H3 as={'H2'} mod={['slantedtoleft', 'white']}>
					{title}
				</Theme.H3>
			</div>
			<div class={styles('actions')}>
				{filteredActions.map((action) => (
					<ActionCard {...action} />
				))}
			</div>
			{link && (
				<div class={styles('button')}>
					<ButtonPrimary to={link.url}>{link.description}</ButtonPrimary>
				</div>
			)}
		</div>
	)
}
